export const TagHeaderViews = {
  AddTag: ["addTagForm", "addTag"],
  DeleteTag: ["deleteTagForm", "deleteTag"],
} as const;

export const NewDefinitionMessage =
  "MAAS will automatically tag every machine that matches the new definition in the background. This can take some time.";
